import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Grid, Typography, styled } from "@mui/material"

import { useAppDispatch } from "redux/hooks"
import { closeDialog } from "redux/features/dialog/dialogSlice"
import IconSuccess from "assets/icons/success.svg"
import Button from "components/ui/Button"
import { CLIENT_SUBSCRIPTIONS_MATCH } from "config"

const SubscriptionSuccessModal = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleClose = () => {
    dispatch(closeDialog())
    navigate(CLIENT_SUBSCRIPTIONS_MATCH)
  }

  return (
    <Container
      container
      direction="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <img src={IconSuccess} alt={t("features.subscription.success.title")} />
      <Title variant="h6">{t("features.subscription.success.title")}</Title>
      <Close onClick={handleClose}>
        {t("features.subscription.success.back")}
      </Close>
    </Container>
  )
}

export default SubscriptionSuccessModal

const Container = styled(Grid)`
  margin: 81px auto 54px auto;
  max-width: 275px;
  text-align: center;
`
const Title = styled(Typography)`
  font-size: 1.75rem;
  font-weight: 300;
  margin: 73px 0;
`
const Close = styled(Button)`
  background: rgba(0, 169, 149, 0.07);
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 400;
`
